import { useEffect, useState } from "react";
import { initializeMap } from "./map/initializeMap";
import mapboxgl from "mapbox-gl";

export default function App() {
  const [offsetAlert, setOffsetAlert] = useState(false);
  const [noDataAlert, setNoDataAlert] = useState(false);
  const [aerosolAlert, setAerosolAlert] = useState(false);
  const [cloudAlert, setCloudAlert] = useState(false);

  const isLatitude = (num) =>
    num !== null && num !== undefined && isFinite(num) && Math.abs(num) <= 90;
  const isLongitude = (num) =>
    num !== null && num !== undefined && isFinite(num) && Math.abs(num) <= 180;
  const isZoom = (num) =>
    num !== null && num !== undefined && isFinite(num) && Math.abs(num) <= 22;

  mapboxgl.accessToken =
    "pk.eyJ1IjoicG9sYXJnZW9zcGF0aWFsIiwiYSI6ImNramxxbGs1MjA4NnMzMWx5OXIwMDV4YmQifQ.0oV8qhtmR4o7Wi6DdDHBRA";
  var bounds = [
    [-32.801, -15.5],
    [59.87, 45.7147],
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lat = urlParams.get("lat");
    const lng = urlParams.get("lng");
    const zoom = urlParams.get("zoom");

    let map = new mapboxgl.Map({
      container: "tree-map",
      style: "mapbox://styles/polargeospatial/ckjlsqfwd0v1719ohfubbn786",
      center: isLatitude(lat) && isLongitude(lng) ? [lng, lat] : [16, 15],
      zoom: isZoom(zoom) ? zoom : 4,
      maxBounds: bounds,
    });
    initializeMap(
      mapboxgl,
      map,
      setOffsetAlert,
      setNoDataAlert,
      setAerosolAlert,
      setCloudAlert
    );
  }, []);

  return (
    <div>
      <div className="alertContainer">
        {offsetAlert && (
          <div className="offsetAlert">
            Polygons may be offset relative to basemap imagery due to
            differences in imagery and/or{" "}
            <a
              href="https://en.wikipedia.org/wiki/Orthophoto"
              target="_blank"
              rel="noreferrer"
            >
              orthorectification
            </a>
            .
          </div>
        )}
        {noDataAlert && <div className="noData">No data</div>}
        {aerosolAlert && <div className="noData">Aerosol affected area</div>}
        {cloudAlert && <div className="noData">Cloud cover affected area</div>}
      </div>

      <title>PGC Trees</title>
      <main>
        <div id="tree-map" style={{ height: "100vh", width: "100vw" }} />
      </main>
    </div>
  );
}
